import React from 'react'
import RoutesList from '../../pages/Partnerships/Routes/List'
import RoutesUpdate from '../../pages/Partnerships/Routes/Update'
import RoutesCreate from '../../pages/Partnerships/Routes/Create'
import RoutesView from '../../pages/Partnerships/Routes/View'
import PrivateRoute from '../PrivateRoute'
import { CustomSwitch } from '../../components/CustomSwitch'

export const RoutesRouter = (): JSX.Element => (
  <CustomSwitch>
    <PrivateRoute path="/partnerships/routes" exact component={RoutesList} />
    <PrivateRoute
      path="/partnerships/routes/create"
      component={RoutesCreate}
      exact
    />
    <PrivateRoute
      path="/partnerships/routes/view/:id"
      component={RoutesView}
      exact
    />
    <PrivateRoute
      path="/partnerships/routes/update/:id"
      component={RoutesUpdate}
      exact
    />
  </CustomSwitch>
)
